import { render, staticRenderFns } from "./SelectPermissionModal.vue?vue&type=template&id=57c031a1&"
import script from "./SelectPermissionModal.vue?vue&type=script&lang=js&"
export * from "./SelectPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c031a1')) {
      api.createRecord('57c031a1', component.options)
    } else {
      api.reload('57c031a1', component.options)
    }
    module.hot.accept("./SelectPermissionModal.vue?vue&type=template&id=57c031a1&", function () {
      api.rerender('57c031a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/SelectPermissionModal.vue"
export default component.exports